import React from 'react';
import Reflux from 'reflux';
import {Input, Button, InputNumber, Modal, Table, Popconfirm} from 'antd';
import {hashHistory} from 'react-router';
import {DmsTab, TableView, DisplayForm} from '../../components';
import {openNotice} from 'Utils';
import {getCompanyLink, deleteLink, addLink} from '../../service/customOrder';

const EditableCell = ({editable, value, onChange}) => (
    <div>
        {editable
            ? <Input style={{margin: '-5px 0'}} value={value} onChange={event => onChange(event.target.value)}/>
            : value
        }
    </div>
);

class CompanyLink extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['生产公司联系方式'],
            key: '',
            submitRows: [],
            count: 42,
            rows: [],
            visible: false,
            selectedRowKeys: [],
            //获取登录人信息数据
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || '',
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            searchObj: {

                id: '',
                linkman: '',
                s: 10,
                p: 1,
            },

        };

        this.pageChange = this.pageChange.bind(this);

    }

    /*修改输入框的onChange事件*/
    handleChange(value, key, column) {
        const newData = [...this.state.rows];
        const target = newData.filter(item => key === item.id)[0];
        console.log(target);
        console.log(newData);
        target[column] = value;
        this.setState({
            rows: newData
        });
        console.log(target[column]);
    }

    goBack() {
        hashHistory.goBack();
        //this.goView('order');
    }

    pageChange(page, s) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s, p: page}}, function () {
            self.initData();
        });
    }

    searchHandler = (event) => {
        this.setState({visible: true});
        // this.getAddArray();
    }


    initData() {
        let self = this;
        let searchObj = this.state.searchObj;
        self.setState({
            loading: true
        });
        getCompanyLink(searchObj).then(function (result) {
            console.log(result)
            if (result.status) {
                if (result && result.code == 200) {
                    self.setState({
                        'rows': result.data || [],
                        'total': result.total,
                        'loading': false
                    });
                } else {
                    openNotice('error', '数据获取失败', '');
                }
            }
        });
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeys, selectedRows});
        // console.log()
    }

    /*保存功能*/
    createHandler2 = (value) => {
    }

    deleteLine = () => {
        const {selectedRows, selectedRowKeys} = this.state;
        const flag = selectedRows.some(item => item.removeFlag !== 0);
        console.log(flag)
        if (selectedRowKeys.length == 0) {
            openNotice('warning', '请选择需要删除的联系方式！', '');
            return false;
        }
        deleteLink(this.state.selectedRowKeys).then((result) => {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '');
                this.initData();
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
                this.setState({loading: false});
            }
        });
    }

    /*新增行*/
    saveRows = (record, text) => {
        const self = this;
        var Rows = [...this.state.rows];
        console.log(Rows);
        var addSave = [{...record}];
        addSave.id = '';
        addSave.area = '';
        addSave.company = '';
        addSave.productionWorkshop = '';
        addSave.tel = '';
        addSave.phone = '';
        addSave.linkMan = '';
        Rows.total++;
        Rows.push(addSave);
        self.setState({rows: Rows});
        openNotice('success', '联系方式添加成功');
    }

    edit(key) {
        let self = this;
        var Rows = [...self.state.rows];
        const target = Rows.filter(item => key === item.id)[0];
        if (target) {
            target.editable = true;
            this.setState({rows: Rows});
        }
    }

    save(value, key) {
        let self = this;
        var Rows = [...self.state.rows];
        console.log(Rows);
        const target = Rows.filter(item => key === item.id)[0];
        const param = {
            id: target.id,
            area: target.area,
            company: target.company,
            productionWorkshop: target.productionWorkshop,
            tel: target.tel,
            phone: target.phone,
            linkMan: target.linkMan,
            removeFlag: target.removeFlag,
        }
        console.log(target);
        if (param.area == "" || param.area == null) {
            openNotice('warning', '请输入修改后的地区');
            return
        }
        if (param.company == "" || param.company == null) {
            openNotice('warning', '请输入修改后的生产公司');
            return
        }
        if (param.productionWorkshop == "" || param.productionWorkshop == null) {
            openNotice('warning', '请输入修改后的生产车间');
            return
        }
        if (param.tel == "" || param.tel == null) {
            openNotice('warning', '请输入修改后的电话号码');
            return
        }
        if (param.phone == "" || param.phone == null) {
            openNotice('warning', '请输入修改后的手机号码');
            return
        }
        if (param.linkMan == "" || param.linkMan == null) {
            openNotice('warning', '请输入修改后的联系人');
            return
        }
        addLink(param).then(res => {
            if (res && res.code == 200) {
                openNotice('success', '添加成功', '');
                this.initData();
            } else {
                openNotice('error', '添加失败', (res && res.message) ? res.message : '');
                this.setState({loading: false});
                console.log(res);
            }
        });
    }

    cancel(key) {
        const newData = [...this.state.rows];
        console.log(this.state.userData);
        console.log(key);
        for (var i = 0; i < newData.length; i++) {
            const target = newData.filter(item => key === item.key)[i];
            if (target) {
                Object.assign(target, this.cacheData.filter(item => key === item.key)[i]);
                delete target.editable;
                this.setState({rows: newData});
            }
        }
    }

    renderColumns(text, record, column) {
        return (
            <EditableCell
                editable={record.editable}
                value={text}
                onChange={value => this.handleChange(value, record.id, column)}
            />
        );
    }

    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        //  let self = this;
        this.initData();
    }

    componentDidMount() {
        // if(this.state.userData.roleCode != 'Admin' && this.state.userData.roleId ==  null){
        //     this.setState({
        //         button_limits_end: false,
        //     });
        // }
    }


    render() {
        var self = this;
        const {opts, total, searchObj, rows, key, selectedRowKeys, button_limits_end} = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数*/
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '序号',
                    dataIndex: 'id',
                    width: '13%',
                }, {
                    title: '地区',
                    dataIndex: 'area',
                    width: '13%',
                    render: (text, record) => this.renderColumns(text, record, 'area'),
                }, {
                    title: '生产公司',
                    dataIndex: 'company',
                    width: '13%',
                    render: (text, record) => this.renderColumns(text, record, 'company'),
                }, {
                    title: '生产车间',
                    dataIndex: 'productionWorkshop',
                    width: '13%',
                    render: (text, record) => this.renderColumns(text, record, 'productionWorkshop'),
                }, {
                    title: '座机',
                    dataIndex: 'tel',
                    width: '13%',
                    render: (text, record) => this.renderColumns(text, record, 'tel'),
                }, {
                    title: '手机号',
                    dataIndex: 'phone',
                    width: '13%',
                    render: (text, record) => this.renderColumns(text, record, 'phone'),
                }, {
                    title: '联系人',
                    dataIndex: 'linkMan',
                    width: '13%',
                    render: (text, record) => this.renderColumns(text, record, 'linkMan'),
                }, {
                    title: '操作',
                    dataIndex: 'edit',
                    width: '13%',
                    render: (text, record, index) => {
                        const {editable} = record;
                        if (button_limits_end.info_list_01) {
                            return (<div>
                                {
                                    editable ?
                                        <span>
                                <Button onClick={() => this.save(text, record.id)}>保存</Button>
                                 <Popconfirm title="确定取消吗？" onConfirm={() => this.cancel(record.key)}>
                                <Button>取消</Button>
                                </Popconfirm>
                                    </span> : <Button
                                            onClick={() => this.edit(record.id)}>编辑</Button>
                                }
                            </div>)
                        }
                    }
                }
            ],

            rows,

            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange
            }
        };
        this.cacheData = rows.map(item => ({...item}));
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                <div className="dms-body">
                    <Button onClick={this.goBack}>返回</Button>
                </div>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <div className="dms-body">
                        {button_limits_end.info_list_01 &&
                        <Button
                            style={{background: '#red',}}
                            icon="plus"
                            onClick={this.saveRows.bind(this)}>添加</Button>
                        }
                        {button_limits_end.info_list_01 &&
                        <Button style={{left: '12px'}}
                                className="editable-add-btn"
                                onClick={this.deleteLine}>删除</Button>
                        }
                    </div>
                    <TableView {...tableViewProps} />
                </div>
            </div>
        </div>

    }
}

export default CompanyLink;


// WEBPACK FOOTER //
// ./src/routes/print/companyLink.js